import React from 'react'
// libs
import { useMutation } from '@apollo/client/react'
// components
import { Modal } from 'components/UI'
// constants
import { Modals } from 'constants/index'
// hooks
import { useModalData } from 'hooks/index'
// themes
import { CloseIcon } from 'components/UI/Icons'
// graphql
import { PREVIEW_EMAIL } from 'graphql/systemProcesses/mutations'
// views
import { Content, ContentWrapper, Header, Wrapper } from './view'
// utils
import { parseGraphQLErrorMessages } from 'utils/errors/parsers'

const PAPER_PROPS = {
  style: {
    margin: 0,
    overflow: 'auto',
    position: 'fixed' as any,
    height: '90vh',
    minWidth: 800
  }
}

type EmailPreview = {
  subject: string
  template: string
}

type QueryResponse = { previewEmail: EmailPreview }

const DEFAULT_PREVIEW = { subject: '', template: '' }

const EmailPreviewModal: React.FC = () => {
  const [previewEmailMutation] = useMutation<QueryResponse>(PREVIEW_EMAIL)

  const [emailPreview, setEmailPreview] = React.useState<EmailPreview>(DEFAULT_PREVIEW)

  const {
    hideModal,
    modalData: { isOpen, subject, template }
  } = useModalData({ modalType: Modals.EMAIL_PREVIEW_MODAL })

  const previewEmail = async (): Promise<void> => {
    try {
      const {
        data: { previewEmail }
      } = await previewEmailMutation({
        variables: {
          input: {
            subject: subject || 'Subject',
            template
          }
        }
      })

      setEmailPreview(previewEmail)
    } catch (error) {
      console.log('[EmailPreviewModal.previewEmail]', parseGraphQLErrorMessages(error))
    }
  }

  React.useEffect(() => {
    if (isOpen && template) {
      previewEmail()
    } else {
      setEmailPreview(DEFAULT_PREVIEW)
    }
  }, [isOpen])

  return (
    <Modal hideBackdrop isOpen={isOpen} disableBackdropClick disableEscapeKeyDown PaperProps={PAPER_PROPS}>
      <Wrapper>
        <Header>
          <span>Email Preview</span>
          <CloseIcon right={0} onClick={hideModal} />
        </Header>
        <ContentWrapper>
          <Content>
            <div>{emailPreview.subject}</div>
            <iframe
              sandbox=''
              srcDoc={`<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap"><style>*{font-family:'Roboto',Helvetica,Arial,sans-serif;}img{max-width:100%;height:auto;}body{margin:0;padding:0 32px;}</style>${emailPreview.template ?? ''}`}
            />
            <div>The skefto.com Team</div>
          </Content>
          <span>Skefto Pty Ltd. | Level 14/440 Collins St. Melbourne, Victoria 3000, Australia</span>
        </ContentWrapper>
      </Wrapper>
    </Modal>
  )
}

export default EmailPreviewModal
